import { Observable, switchMap } from 'rxjs';
import {
  createAuthorizationHeaders,
  createRequestQuery,
  delete$,
  get$,
  post$,
} from 'services/axios';
import {
  BankTransactionListResponse,
  SystemTransactionListResponse,
  TransactionArchivePayload,
  TransactionArchiveResponse,
  TransactionMatchPayload,
  TransactionMatchResponse,
  TransactionRestorePayload,
  TransactionUnmatchPayload,
  TransactionAutoMatchPayload,
  TransactionAutoMatchResponse,
} from 'types/dto';
import { QueryParams } from 'types/transport';

/**
 * Create an observable emitting bank transaction response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createGetBankTransactionList$ =
  (token$: Observable<string>) => (query?: QueryParams) =>
    token$.pipe(
      switchMap(token =>
        get$<BankTransactionListResponse>(
          `/v1/bank-transactions`,
          createAuthorizationHeaders(token),
          createRequestQuery(query),
        ),
      ),
    );

/**
 * Create an observable emitting system transaction response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createGetSystemTransactionList$ =
  (token$: Observable<string>) => (query?: QueryParams) =>
    token$.pipe(
      switchMap(token =>
        get$<SystemTransactionListResponse>(
          `/v1/system-transactions`,
          createAuthorizationHeaders(token),
          createRequestQuery(query),
        ),
      ),
    );

/**
 * Create an observable emitting transaction archive response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createArchiveTransactionList$ =
  (token$: Observable<string>) => (payload: TransactionArchivePayload) =>
    token$.pipe(
      switchMap(token =>
        post$<TransactionArchiveResponse>(
          `/v1/transactions/ignore`,
          payload,
          createAuthorizationHeaders(token),
        ),
      ),
    );

/**
 * Create an observable emitting transaction match response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createMatchTransactionList$ =
  (token$: Observable<string>) => (payload: TransactionMatchPayload) =>
    token$.pipe(
      switchMap(token =>
        post$<TransactionMatchResponse>(
          `/v1/transactions/match`,
          payload,
          createAuthorizationHeaders(token),
        ),
      ),
        );

/**
 * Create an observable emitting transaction match response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createAutoMatchTransactionList$ =
    (token$: Observable<string>) => (payload: TransactionAutoMatchPayload) =>
        token$.pipe(
            switchMap(token =>
                post$<TransactionAutoMatchResponse>(
                    `/v1/transactions/automatch`,
                    payload,
                    createAuthorizationHeaders(token),
                ),
            ),
        );

/**
 * Create an observable emitting transaction restore response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createRestoreTransactionList$ =
  (token$: Observable<string>) => (payload: TransactionRestorePayload) =>
    token$.pipe(
      switchMap(token =>
        delete$<void>(`/v1/transactions/ignore`, payload, createAuthorizationHeaders(token)),
      ),
    );

/**
 * Create an observable emitting transaction unmatch response
 *
 * @param {Observable<string>} token$ Observable emitting the latest access token
 */
export const createUnmatchTransactionList$ =
  (token$: Observable<string>) => (payload: TransactionUnmatchPayload) =>
    token$.pipe(
      switchMap(token =>
        delete$<void>(`/v1/transactions/match`, payload, createAuthorizationHeaders(token)),
      ),
    );
